module.exports = __webpack_public_path__ + "assets/media/user-member-lovel06.7aded155.png";